import { Directive, EffectRef, HostBinding, OnDestroy, effect, inject, signal } from '@angular/core';
import { FEATURE_SETTINGS, IFeatureSettings } from '@partners/settings';
import { ShellStore } from '@partners/state';

@Directive({
  selector: '[featureSettings]',
  standalone: true
})
export class FeatureSettingsDirective implements OnDestroy {
  @HostBinding('class.fixed-footer')
  get hasStickyFooter() {
    // return this._featureSettings().isFooterFixed;
    const viewSettings = this._shellStore.viewSettings$$();
    return viewSettings?.isFooterFixed;
  }

  private _effectRef: EffectRef;
  private _shellStore = inject(ShellStore);
  private _featureSettings = signal<IFeatureSettings>(inject(FEATURE_SETTINGS));

  constructor() {
    this._effectRef = effect(
      () => {
        const { isFooterFixed, isProgressHidden, isProgressRendered, headerCloseAction } = this._featureSettings();

        this._shellStore.dispatchUpdateShellView({
          isFooterFixed,
          isProgressHidden,
          isProgressRendered,
          headerCloseAction
        });
      },
      { allowSignalWrites: true }
    );
  }

  ngOnDestroy(): void {
    this._effectRef && this._effectRef.destroy();
  }
}
